import { render, staticRenderFns } from "./CategoryMenuGroupSummary.vue?vue&type=template&id=b368e7b8&scoped=true"
import script from "./CategoryMenuGroupSummary.vue?vue&type=script&lang=js"
export * from "./CategoryMenuGroupSummary.vue?vue&type=script&lang=js"
import style0 from "./CategoryMenuGroupSummary.vue?vue&type=style&index=0&id=b368e7b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b368e7b8",
  null
  
)

export default component.exports